<template>
  <main class="container-fluid container-main">
    <div class="hidden-xs hidden-sm">
      <main-nav></main-nav>

      <transition name="fade"
                  mode="out-in">
        <div class="app-view">
          <router-view :key="$route.fullPath">
        </router-view>
        </div>
      </transition>

      <copyright></copyright>
    </div>
    <div class="hidden-md hidden-lg">
      <responsive></responsive>
    </div>
  </main>
</template>

<script>
import Responsive from './components/ResponsiveComponent'
import MainNav from './components/partials/MainNav'
import Home from './components/HomeComponent'
import Copyright from './components/partials/Copyright'

export default {
  components: {
    Responsive,
    MainNav,
    Home,
    Copyright
  },
  created: function () {
    this.$http.get(global.api + 'languages').then(function (response) {
      var languagesData = JSON.parse(response.bodyText)

      var languagesOrder = [
        {
          family: 'français',
          name: 'moderne'
        },
        {
          family: 'français',
          name: 'littéraire'
        },
        {
          family: 'français',
          name: 'littéral'
        },
        {
          family: 'english',
          name: 'modern'
        },
        {
          family: 'italiano',
          name: 'moderno'
        },
        {
          family: 'español, castellano',
          name: 'moderno'
        },
        {
          family: 'ελληνικά',
          name: 'αρχαία'
        },
        {
          family: 'ελληνικά',
          name: 'ancient Cagnazzi'
        },
        {
          family: 'ελληνικά',
          name: 'ancient Majorna'
        },
        {
          family: 'ελληνικά',
          name: 'ancient perseus'
        },
        {
          family: 'ellenika',
          name: 'ancient katerina'
        }
      ]

      // Reverse, push to top favourite lang at the end
      var reverseLanguagesOrder = Array.prototype.reverse.call(languagesOrder)

      // Re-order languages in order of priority
      reverseLanguagesOrder.forEach(function (favLanguage) {
        languagesData.forEach(function (lang, index) {
          if (lang.family === favLanguage.family) {
            if (lang.name === favLanguage.name) {
              languagesData.splice(0, 0, languagesData.splice(index, 1)[0])
            }
          }
        })
      })

      global.languages = languagesData
    })
  }
}

/**
 * Parse language versions and return the most accurate one
 * @param {array} versions Collection containing all the versions of a given data.
 * @param {string} desiredProp Property name we're looking after.
 * @return {object} The nested object matching language version
 */
global.parseVersion = function (versions) {
  // Iterate over each language, starting with the first (favourite)
  // then progressing over each next language.
  for (var i = 0; i < global.languages.length; i++) {
    // Parse the versions of the data
    // If the version ID matches the one of our current favourite language,
    // return that version, otherwise loop again until the next favourite language.
    for (var y = 0; y < versions.length; y++) {
      if (versions[y].id_language === global.languages[i].id_language) {
        return versions[y]
      }
    }
  }
}
</script>

<style lang="sass">
$hover: .5s all ease-out
$raleway: 'Raleway', Helvetica, Arial, sans-serif

.fade-enter-active,
.fade-leave-active
  transition: opacity .8s ease

.fade-enter,
.fade-leave
  opacity: 0

@font-face
  font-family: 'times'
  src: url('/static/fonts/times/Times-Roman.ttf')
@font-face
  font-family: 'times'
  src: url('/static/fonts/times/Times-Italic.ttf')
  font-style: italic
@font-face
  font-family: 'times'
  src: url('/static/fonts/times/Times-BoldItalic.ttf')
  font-style: italic
  font-weight: bold
@font-face
  font-family: 'times'
  src: url('/static/fonts/times/Times-Bold.ttf')
  font-weight: bold

html
  height: 100%

body
  display: flex
  height: 100%
  font-family: 'times', Helvetica, Arial, sans-serif
  overflow: hidden

  .scroll
    overflow-y: scroll
    overflow-x: hidden

    &::-webkit-scrollbar
      display: none

a
  outline: none

  &:hover,
  &:focus,
  &visited
    outline: none

sup
  padding: 0 8px
  font-weight: 700

.container-main
  width: 100%
  height: 100%
  padding: 19px 17px

  >div
    width: 100%
    height: 100%
    overflow: hidden

.navbar-default
  background: none
  border: none

q
  quotes: "\201C" "\201D" "\2018" "\2019"
  position: relative
  padding: 0 10px 10px 0

  &:before
    font-size: 30px
    position: absolute
    top: -40px
    left: -20px

  &:after
    display: none

span.bg
  width: 20px
  height: 20px
  background: #e4e4e4
  position: absolute
  left: 0
  top: 50%
  transform: translate3d(0, -50%, 0)
  z-index: -1
  transition: $hover

.dash
  background: #2c2c2c
  display: inline-block
  vertical-align: top

.page-title-container
  position: absolute
  top: 50%
  left: 50%
  transform: translate3d(-50%, -50%, 0)
  font-family: $raleway
  text-align: center
  opacity: .04
  z-index: -1
  width: 68%

  h1
    text-transform: uppercase
    font-size: 100px
    font-weight: 800
    max-width: 95%
    overflow: hidden
    white-space: nowrap
    text-overflow: ellipsis
    margin: 0 auto

.app-view
  width: 100%
  height: calc(100% - 100px)
  //top: 100px
  position: relative

.page-subtitle-container
  margin: 0 0 40px

  .dash
    width: 24px
    height: 2px
    margin-right: 40px
    margin-top: 16px

  h2
    display: inline-block
    font-size: 30px
    font-style: italic
    margin: 0
    line-height: 32px

.vertical-list-container
  columns: 20em
  // do not balance columns (firefox)
  // see https://css-tricks.com/guide-responsive-friendly-css-columns/#article-header-id-9
  column-fill: auto

  width: 100%
  //height: 50%
  //align-self: center

.vertical-list-wrapper
  padding-top: 10px

  h3,
  h4
    padding-left: 10px
    position: relative
    font-family: $raleway
    font-size: 10px
    font-weight: 700
    color: rgba(44,44,44,.5)
    margin: 0
    text-transform: uppercase
    letter-spacing: 0.1em
    height: 50px
    line-height: 50px

    sup
        font-family: initial
        font-size: 8px
        color: #2c2c2c

  ul
    list-style: none
    padding: 0
    margin: 15px 0
    height: 100%

    li
      padding-left: 20px

      a
        font-size: 12px
        color: #2c2c2c
        transition: $hover
        padding: 5px 0
        display: block

        &:hover
          padding-left: 10px
          text-decoration: none

.inner-links
  padding: 12px 0 33px

  .dash
    width: 19px
    height: 1px
    margin-right: 10px
    display: inline-block
    position: relative
    background: none

    &:before
      content: ''
      display: block
      position: absolute
      left: 0
      bottom: 0
      height: 1px
      width: 0
      transition: width 0s ease, background .5s ease

    &:after
      content: ''
      display: block
      position: absolute
      right: 0
      bottom: 0
      height: 1px
      width: 0
      background: #2c2c2c
      transition: width .5s ease

  a,
  button
    font-family: $raleway
    font-size: 12px
    font-weight: 600
    color: #2c2c2c
    display: flex
    align-items: center
    letter-spacing: 0.04em

    &:hover,
    &:hover
      text-decoration: none

      .dash
        &:before
          width: 100%
          background: #2c2c2c
          transition: width .5s ease

        &:after
          width: 100%
          background: transparent
          transition: all 0s ease

.type-text-bg
  position: absolute
  top: 50%
  left: 0
  transform: translate3d(0, -50%, 0)
  text-transform: uppercase
  font-family: $raleway
  font-size: 36px
  font-weight: 900
  color: rgba(44, 44, 44, .08)
  opacity: 0
  transition: $hover
  z-index: -1
  letter-spacing: 2px

.search-component
  width: 100%
  height: 100%

  >.row
    width: 100%
    height: 100%

  .page-subtitle-container
    position: absolute
    bottom: 0
    left: 0

  .left-column
    height: 100%
    display: flex
    flex-direction: column
    justify-content: center
    position: relative

    .search-title-container
      h3
        font-size: 18px
        font-weight: 700
        text-transform: capitalize
        display: inline-block
        letter-spacing: 1px

        span
          display: inline-table
          padding-bottom: 1px

          &:after
            content: ""
            width: 100%
            height: 1px
            background: #2c2c2c
            display: inline-block
            vertical-align: top

        sup
          font-size: 12px
          font-style: italic
          color: rgba(44, 44, 44, .5)
          vertical-align: super

    .search-subtext-container
      position: relative
      margin-left: 100px

      p
        font-size: 18px
        font-style: italic

        .type-text-bg
          opacity: 1
          font-style: normal
          font-size: 48px
          padding-left: 10px

    .search-desc-container
      width: 300px
      margin: 80px 0

      q
        line-height: 20px

        &:before
          top: 0

  .right-column
    height: 100%
    display: flex
    flex-direction: column
    justify-content: flex-end

    .vertical-list-container
      height: 27%

    .img-container
      align-self: flex-end
      margin-right: 130px
      margin-bottom: 45px
      margin-top: 100px
      width: 250px
      height: 250px

.notExist
  width: 100%
  height: 100%
  display: flex
  align-items: center
  justify-content: center
  position: relative
  flex-direction: column
  display: none

  p
    font-size: 30px
    color: #2c2c2c

  .back-btn

// Rows
.row--all
  height: 100%
  > div
    height: 100%
    display: flex
    flex-direction: column
    justify-content: space-between

  .vertical-list-container
    height: 100%
</style>



// WEBPACK FOOTER //
// App.vue?afb2613c